"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Footer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens/lib/tokens"));

var types = _interopRequireWildcard(require("../../types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyles__Footer",
  componentId: "sc-1ap4cog-0"
})(function (_ref) {
  var size = _ref.size;
  return (0, _styledComponents.css)(["align-items:center;background:", ";box-sizing:border-box;display:flex;flex-shrink:0;height:", ";padding:", ";position:relative;transition:opacity 0.3s ease-in;width:100%;[data-pka-anchor=\"button\"]:not(:last-child){margin-right:", ";}"], _tokens["default"].color.blackLighten70, size === types.sizes.MEDIUM ? "".concat(_stylers["default"].spacer(7)) : "68px", size === types.sizes.MEDIUM ? "".concat(_tokens["default"].spaceLg, " ").concat(_stylers["default"].spacer(2)) : "".concat(_stylers["default"].spacer(2), " ").concat(_stylers["default"].spacer(3)), _tokens["default"].space);
});

exports.Footer = Footer;
//# sourceMappingURL=Footer.styles.js.map